/* eslint-disable react/no-unknown-property */
import { FC } from 'react';

export const IconCheck: FC<{ testId?: string }> = ({ testId }) => (
  <span
    {...(testId && { 'test-id': testId })}
    className="c-nav-validation-popover-icon-check"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <circle cx="10" cy="10" r="10" fill="#49B77D" />
      <path
        d="M6 10.5L9 13.5L14 7.5"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
